import { ChevronRight, Wrench } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { t } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** Collapsible "Technical details" area for debug information (executions, pods, raw events, logs) — or, retitled, for anything else kept out of the way. */
export function TechDetails({
  children,
  title = t('Technical details'),
  description = t('For troubleshooting and developers — you don’t need this for everyday work.'),
  defaultOpen = false,
  className,
  icon = <Wrench />,
}: {
  children: ReactNode;
  title?: string;
  description?: string;
  defaultOpen?: boolean;
  className?: string;
  icon?: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible open={open} onOpenChange={setOpen} className={cn('rounded-xl border bg-card', className)}>
      <CollapsibleTrigger className="flex w-full cursor-pointer items-center gap-2 px-5 py-3.5 text-left">
        <ChevronRight className={cn('size-4 text-muted-foreground transition-transform', open && 'rotate-90')} />
        <span className="flex text-muted-foreground [&_svg]:size-4">{icon}</span>
        <span className="text-sm font-semibold">{title}</span>
        <span className="hidden truncate text-[13px] text-muted-foreground sm:inline">— {description}</span>
      </CollapsibleTrigger>
      <CollapsibleContent className="border-t px-5 py-4">{open ? children : null}</CollapsibleContent>
    </Collapsible>
  );
}
